import { getFileMimeType } from './getFileMimeType';

export const downloadFile = (
  fileSource: string,
  fileExtension: string,
  docType: string,
  openPdfInNewTab: boolean = true
) => {
  const fileMimeType = getFileMimeType(fileExtension);
  const url = base64ToURL(fileSource, fileMimeType);
  const a = document.createElement('a');
  document.body.appendChild(a);

  a.setAttribute('style', 'display: none');
  a.href = url;
  a.download = docType;
  a.click();

  window.URL.revokeObjectURL(url);
};

export const base64ToURL = (base64: string, fileMimeType: string) => {
  const bs = window.atob(base64);
  const buffer = new ArrayBuffer(bs.length);
  const ba = new Uint8Array(buffer);
  for (let i = 0; i < bs.length; i++) {
    ba[i] = bs.charCodeAt(i);
  }
  const file = new Blob([ba], { type: fileMimeType });
  const url = window.URL.createObjectURL(file);
  return url;
};
